import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/Layout.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/home/Home.vue"),
        meta: { title: "首页" },
      },
      {
        path: "enterprise",
        name: "enterpriseList",
        component: () => import("@/views/enterprise/ProductList.vue"),
        meta: { title: "企业集采" },
      },
      {
        path: "enterprise/product/:id",
        name: "enterpriseDetail",
        component: () => import("@/views/enterprise/ProductDetail.vue"),
        meta: { title: "企业集采商品详情" },
      },
      {
        path: "enterprise/cart",
        name: "enterpriseCart",
        component: () => import("@/views/enterprise/Cart.vue"),
        meta: { title: "集采购物车" },
      },
      {
        path: "enterprise/checkout",
        name: "enterpriseCheckout",
        component: () => import("@/views/enterprise/Checkout.vue"),
        meta: { title: "确认订单" },
      },
      {
        path: "enterprise/order-query",
        name: "enterpriseOrderQuery",
        component: () => import("@/views/enterprise/OrderQuery.vue"),
        meta: { title: "集采订单查询" },
      },
      {
        path: "selection",
        name: "selectionList",
        component: () => import("@/views/dealer/ProductList.vue"),
        meta: { title: "经销商选品", requiresAuth: true },
      },
      {
        path: "selection/product/:id",
        name: "selectionDetail",
        component: () => import("@/views/dealer/ProductDetail.vue"),
        meta: { title: "选品商品详情", requiresAuth: true },
      },
      {
        path: "selection/records",
        name: "selectionRecords",
        component: () => import("@/views/dealer/Records.vue"),
        meta: { title: "商城记录", requiresAuth: true },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/dealer/Login.vue"),
    meta: { title: "经销商登录" },
  },
];

const router = new VueRouter({
  mode: "history",
  // 生产部署在 /selection/ 子路径下（.env.production VUE_APP_BASE_URL），开发环境仍是根路径
  base: process.env.VUE_APP_BASE_URL || "/",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 铠盾商城`;
  }
  if (to.matched.some((r) => r.meta.requiresAuth) && !store.getters.isLogin) {
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }
  next();
});

export default router;
